import type { PostgrestError } from "@supabase/supabase-js";

/**
 * Linhas por página. O Supabase na nuvem devolve no máximo 1000 linhas por consulta
 * (configuração Max rows do Data API), mesmo com .limit() maior: sem paginar, uma lista
 * de posições ou produtos maior que isso chega cortada sem aviso.
 */
export const PAGINA = 1000;

type Resposta<T> = { data: T[] | null; error: PostgrestError | null };

/**
 * Lê todas as linhas de uma consulta, página por página. `montar(de, ate)` devolve a mesma
 * consulta com `.range(de, ate)`; a ordem precisa terminar numa coluna única (código, id)
 * para nenhuma linha pular ou repetir entre as páginas.
 */
export async function lerTodas<T>(montar: (de: number, ate: number) => PromiseLike<Resposta<T>>, maximo = 50_000): Promise<T[]> {
  const linhas: T[] = [];
  for (let de = 0; de < maximo; de += PAGINA) {
    const { data, error } = await montar(de, de + PAGINA - 1);
    if (error) throw error;
    const pagina = data ?? [];
    linhas.push(...pagina);
    if (pagina.length < PAGINA) break;
  }
  return linhas;
}
